<header class="sub-page-layout__header feeSchedules__header">
  <div class="feeSchedules__header-text h2 h2--semi-bold">Fee Schedules</div>
  <mat-slide-toggle
    class="feeSchedules__active-toggle"
    [checked]="activeFilter === 'active'"
    color="primary"
    (change)="showInactiveChanges($event)"
  >
    <div *ngIf="activeFilter !== 'inactive'">Active</div>
    <div *ngIf="activeFilter === 'inactive'">Inactive</div>
  </mat-slide-toggle>
  <button mat-flat-button color="primary" class="feeSchedules__add-item" (click)="addFeeSchedule()" *ngIf="!viewOnly">
    <mat-icon>add_circle_outline</mat-icon> Add Fee Schedule
  </button>
</header>
<div *ngIf="dataSource && gridConfig" class="lib-grid__grid-container">
  <lib-grid [dataSource]="dataSource" [gridConfiguration]="gridConfig">
    <div class="">
      <h4>No Fee Schedules Found.</h4>
    </div>
  </lib-grid>
</div>
<footer *ngIf="isImplementation" class="feeSchedules__footer">
  <lib-button-loading color="primary" class="feeSchedules__button" (clickEvent)="next()">Next </lib-button-loading>
</footer>
